import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpinnakerComponent } from './simple-icons-spinnaker.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpinnakerComponent ],
    exports:      [ SimpleIconsSpinnakerComponent ],
    bootstrap:    []
})
export class SimpleIconsSpinnakerModule {}
